"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableServicesArray = void 0;
exports.availableServicesArray = ["guardia", "online", "consultorio", "prescription", "chatAtt", "quickPrescription", "betaGuardia"];
